function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/css';
import '../../styles/global';
import { cache } from '../utils';
export var makeStyles = cache(function makeStyles(k) {
  return /*#__PURE__*/css(process.env.NODE_ENV === "production" ? {
    name: "t3aops",
    styles: "cursor:pointer;vertical-align:middle"
  } : {
    name: "t3aops",
    styles: "cursor:pointer;vertical-align:middle",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  });
});